import script from "./ModalSuccessIntegrations.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalSuccessIntegrations.vue?vue&type=script&setup=true&lang=ts"

import "./ModalSuccessIntegrations.vue?vue&type=style&index=0&id=b635d240&lang=scss"

const __exports__ = script;

export default __exports__